import { ReactNode, memo, useEffect } from 'react';

import { useDispatch, useSelector } from 'store';
import { activeItem } from 'store/slices/menu';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

import { useLocation } from 'react-router-dom';
// project imports
import NavItem from 'layout/MainLayout/Sidebar/MenuList/NavItem';
import NavCollapse from 'layout/MainLayout/Sidebar/MenuList/NavCollapse';
import { GenericCardProps, NavItemType } from 'types';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

export interface NavGroupProps {
  item: {
    id?: string;
    type?: string;
    icon?: GenericCardProps['iconPrimary'];
    children?: NavGroupProps['item'][];
    title?: ReactNode | string;
    caption?: ReactNode | string;
    color?: 'primary' | 'secondary' | 'default' | undefined;
  };
}

const NavGroup = ({ item }: NavGroupProps) => {
  const theme = useTheme();
  const { drawerOpen } = useSelector((state) => state.menu);

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  // One of two places where navbar handling of URL happens
  // The other is ../NavItem/index
  useEffect(() => {
    const children = item.children || [];
    children.forEach((child: NavItemType) => {
      if (pathname === child.url) {
        dispatch(activeItem([child.id!]));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  // menu list collapse & items
  const items = item.children?.map((menu) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      {/* group divider */}
      {drawerOpen && <Divider sx={{ mt: 1, mb: 0.5 }} />}
      <List
        sx={drawerOpen ? {} : { py: 0 }}
        subheader={
          drawerOpen &&
          item.title && (
            <Typography
              variant="caption"
              sx={{
                ...theme.typography.menuCaption,
                mt: 0,
                pt: 0,
                pl: 0,
                ml: 0,
              }}
              display="block"
              gutterBottom
              title={String(item.title)}
            >
              {item.title}
              {item.caption && (
                <Typography
                  variant="caption"
                  sx={{ ...theme.typography.subMenuCaption }}
                  display="block"
                  gutterBottom
                >
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>
    </>
  );
};

export default memo(NavGroup);
